
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import Dialog from 'primevue/dialog'
import descriptor from './OlapScenarioWizardDescriptor.json'
import InlineMessage from 'primevue/inlinemessage'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'

const deepcopy = require('deepcopy')

export default defineComponent({
    name: 'olap-scenario-wizard',
    components: { Dialog, InlineMessage, Dropdown, Card, Column, DataTable },
    props: {  artifactIdProp: {type: String},  sbiExecutionId: { type: String }, olapDesignerProp: { type: Object, required: true } },
    emits: ['close', 'saveScenario', 'deleteScenario'],
    computed: {
        saveButtonDisabled() {
            let validation = false
            if (this.scenario.VARIABLE) {
                for (let i = 0; i < this.scenario.VARIABLE.length; ++i) {
                    if (Object.keys(this.scenario.VARIABLE[i].name).length === 0 || Object.keys(this.scenario.VARIABLE[i].value).length === 0) {
                        validation = true
                        break
                    }
                }
            }
            this.scenario.MEASURE.length === 0 ? (validation = true) : ''
            return validation
        }
    },
    data() {
        return {
            descriptor,
            showInfo: false,
            loading: false,
            expandParamsCard: true,
            scenario: {} as any,
            selectedCube: { name: '' } as any,
            cubes: [] as any,
            measures: [] as any
        }
    },
    watch: {
        async visible() {
            await this.getAllCubes()
            this.createScenario()
        }
    },
    created() {
        this.getAllCubes()
        this.createScenario()
    },
    methods: {
        createScenario() {
            if (this.olapDesignerProp.template.wrappedObject.olap.SCENARIO) {
                this.scenario = deepcopy(this.olapDesignerProp.template.wrappedObject.olap.SCENARIO)
                this.selectedCube = { name: this.olapDesignerProp.template.wrappedObject.olap.SCENARIO.editCube }
                this.getAllMeasures()
            } else {
                this.scenario = deepcopy(this.descriptor.scenarioTemplate)
            }
        },
        async getAllCubes() {
            const currentContentId = this.artifactIdProp
            await this.$http
                .get(process.env.VUE_APP_OLAP_PATH + `1.0/designer/cubes/${currentContentId}?SBI_EXECUTION_ID=${this.sbiExecutionId}`)
                .then((response: AxiosResponse<any>) => {
                    this.cubes = response.data.map((cube) => ({ name: cube }))
                })
                .catch(() => {})
                .finally(() => (this.loading = false))
        },
        async getAllMeasures() {
            const currentContentId = this.artifactIdProp
            await this.$http
                .get(process.env.VUE_APP_OLAP_PATH + `1.0/designer/measures/${currentContentId}/${this.selectedCube.name}?SBI_EXECUTION_ID=${this.sbiExecutionId}`)
                .then((response: AxiosResponse<any>) => {
                    this.measures = response.data.map((cube) => ({ XML_TAG_TEXT_CONTENT: cube }))
                })
                .catch(() => {})
                .finally(() => (this.loading = false))
        },
        onCubeChange() {
            this.scenario.MEASURE = []
            this.getAllMeasures()
        },

        addNewParam() {
            const newParam = { ...descriptor.newVariable }
            this.scenario.VARIABLE.push(newParam)
        },
        removeAllParams() {
            this.$confirm.require({
                message: this.$t('documentExecution.olap.scenarioWizard.deleteAllMsg'),
                header: this.$t('documentExecution.olap.scenarioWizard.deleteAllTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => (this.scenario.VARIABLE = [])
            })
        },
        removeParam(slotProps) {
            this.scenario.VARIABLE.splice(slotProps.index, 1)
        },
        resetScenarioData() {
            this.scenario = deepcopy(this.descriptor.scenarioTemplate)
            this.selectedCube = {}
            this.$emit('deleteScenario')
        },
        saveScenario() {
            this.scenario.editCube = this.selectedCube.name
            this.$emit('saveScenario', this.scenario, this.selectedCube)
        }
    }
})
